export const getUrlWithQueryParams = (url, override = false) => {
  if (typeof window === 'undefined') return url

  const originalUrl = new URL(url, window.location.origin)
  const currentParams = new URLSearchParams(window.location.search)

  currentParams.forEach((value, key) => {
    if (override) {
      // Overriding existing query params with current ones
      originalUrl.searchParams.set(key, value)
    } else {
      // No overriding, only adding current query params if not present
      // eslint-disable-next-line no-lonely-if
      if (!originalUrl.searchParams.has(key)) {
        originalUrl.searchParams.set(key, value)
      }
    }
  })

  return originalUrl.toString()
}
